import { render } from "./CustomersOrderList.vue?vue&type=template&id=08770654&ts=true"
import script from "./CustomersOrderList.vue?vue&type=script&lang=ts"
export * from "./CustomersOrderList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__